// TR - Turkish
export const locale = {
	lang: 'tr',
	data: {
		SWAL: {
			CONFIRM: 'Onayla',
			CANCEL: 'Reddet',
			BUTTON_OK: 'Tamam',

			SUCCESS: 'İşlem başarıyla gerçekleştirildi.',
			WARNING_TITLE: 'Dikkat Dikkat!',
			WARNING: 'Listeden seçilmiş herhangi bir veri bulunamadı.',
			ERROR_TITLE: 'Bir Hata Oluştu!',
			ERROR: 'İşlem gerçekleştirilirken bir hata oluştu.',
			API_ERROR: 'Veri çekme işlemi sırasında bir hata oluştu. Sayfayı yenileyerek işlemi tekrarlayın. Hata devam ediyorsa iletişime geçin.',
			FORM_INVALID: 'Girilen Form Bilgileri Eksik veya Hatalı!',
			LOGIN_ERROR: 'Girilen E-Posta Adresi ve/veya Şifre Hatalı!',

			GET_LIST_ERROR: 'Kullanıcı Rolleri Getirilemedi!',
			GET_COMPANY_ERROR: 'Şirket Listesi Getirilemedi!',
			GET_USER_ERROR: 'Kullanıcı Listesi Getirilemedi!',
			GET_BRANCH_ERROR: 'Şube Listesi Getirilemedi!',
			GET_COMPANY_DEFTER_ERROR: 'Defter Listesi Getirilemedi!',
			GET_USED_SIZE_BY_COMPANIES: 'Şirkete Ait Kullanılan Boyutlar Getirilemedi!',
			GET_MUKELLEF_ERROR: 'Mükellef Sorumlusu Listesi Getirilemedi!',
			GET_MUKELLEF_TYPE_ERROR: 'Mükellef Tipi Listesi Getirilemedi!',
			GET_USER_ROLE_ERROR: 'Kullanıcı Tipi Listesi Getirilemedi!',
			GET_ANNOUNCEMENT_ERROR: 'Duyuru Listesi Getirilemedi!',
			SCHEMATRON_CONTROL_ERROR: 'Şematron Kontrolü Sırasında Bir Hata Oluştu!',
			SCHEMA_CONTROL_ERROR: 'Şema Kontrolü Sırasında Bir Hata Oluştu!',
			NO_UPDATE_GIB_ERROR: 'Yüklenecek olan XML dosyasında yapısal hata bulunmadı.',

			COMPANY_ADD: 'Şirket ve Sorumlusu Başarıyla Eklendi!',
			BRANCH_ADD: 'Şube Başarıyla Eklendi!',
			DEFTER_INPUT_ADD: 'Defter Başarıyla Yüklendi!',
			MUKELLEF_ADD: 'Mükellef Sorumlusu Başarıyla Eklendi!',
			USER_ADD: 'Kullanıcı Başarıyla Eklendi!',
			ANNOUNCEMENT_ADD: 'Duyuru Başarıyla Eklendi!',

			IMZA: 'İmzalama Başarılı',
			SCHEMA_CONTROL: 'Şema Kontrolü Başarılı!',
			SCHEMATRON_CONTROL: 'Şematron Kontrolü Başarılı!',
			SEND_GIB_SUCCCESS: 'Belgeler Başarıyla GIB\'e Gönderildi! GIB Dönüşü Bekleniyor.',
			SEND_GIB_ERROR: 'Belgeler GIB\'e gönderilirken hata oluştu. Lütfen sistem sorumluları ile iletişime geçin.',
			SEND_GIB_READY: 'Defterin Durumu Başarıyla Güncellendi!',
			SEND_GIB_READY_ERROR: 'Defterin durumu güncellenirken hata oluştu.',
			IKINCIL_KOPYA: "İkincil kopya başarılı bir şekilde indirildi.",
			PRINT_SUCCESS: 'Yazdırma İşlemi Başarılı!',
			UPLOAD_GIB_SUCCESS: 'Dosyalarınızı Yükleme İşlemi Başarılı!',
			CANT_SEND_GIB: 'Defteri GİBe göndermek için doğrulama ve imzalama aşamalarını tamamlayınız.',

			COMPANY_UPDATE: 'Şirket Bilgileri Başarıyla Güncellendi!',
			USER_UPDATE: 'Kullanıcı Bilgileri Başarıyla Güncellendi!',
			BRANCH_UPDATE: 'Şirket Bilgileri Başarıyla Güncellendi!',
			MUKELLEF_UPDATE: 'Mükellef Sorumlusu Bilgileri Başarıyla Güncellendi!',
			ANNOUNCEMENT_UPDATE: 'Duyuru Başarıyla Güncellendi!',
			PARAMETER_UPDATE: 'Parametre Başarıyla Güncellendi!',

			COMPANY_ACTIVE: 'Şirket Başarıyla Aktifleştirildi!',
			COMPANY_PASIVE: 'Şirket Başarıyla Pasifleştirildi!',
			COMPANY_LIQUIDATE: 'Mükellef Tasfiye Süreci Başlatıldı!',
			BRANCH_DELETE: 'Şube Başarıyla Silindi!',
			MUKELLEF_DELETE: 'Mükellef Sorumlusu Başarıyla Silindi.',
			USER_DELETE: 'Kullanıcı Başarıyla Silindi!',
			DEFTER_INPUT_DELETE: 'Defter Başarıyla Silindi!',
			ANNOUNCEMENT_DELETE: 'Duyuru Başarıyla Silindi!',
			TASFIYE_BITIR_TITLE: 'Tasfiye Sonlandırılacak!',
			TASFIYE_BITIR_DESC: 'Bu işlem sonrasında tasfiye edilen şirket herhangi bir defter yükleme işlemi gerçekleştiremez. Bu işlem geri alınamaz. Onaylıyor musunuz?',
			COMPANY_LIQUIDATE_END: 'Şirket Tasfiyesi Başarıyla Gerçekleştirildi!',

			NO_HAVE_MUKELLEF_SORUMLU: 'Defter Yüklemek İçin Mükellef Sorumlusu Tanımlanması Gerekmektedir!',
			FIND_OLD_DEFTER: 'Parçası Eksik Defteriniz Bulunuyor!',
			FIND_NOT_UPLOADED_BRANCH: 'Girişi Yapılmamış Şubeler Bulunuyor!',
			CANT_PARSE_FILE: 'Parçalı Defter "Tek Seferde" Tüm Ayı Kapsayamaz!',
			DEFTER_PARCALANACAK: 'Seçilen "Kaynak Verisi", 200MB aşmayacak şekilde parçalanacaktır.',
		},
		MENU: {
			DASHBOARD: 'Ana Sayfa',
			SETTING: 'Ayarlar',
			USER: {
				ROOT: 'Kullanıcı İşlemleri',
				ADD: 'Kullanıcı Ekle',
				LIST: 'Kullanıcı Listesi',
			},
			COMPANY: {
				ROOT: 'Şirket İşlemleri',
				ADD: 'Şirket Ekle',
				LIST: 'Şirket Listesi',
			},
			BRANCH: {
				ROOT: 'Şube İşlemleri',
				ADD: 'Şube Ekle',
				LIST: 'Şube Listesi',
			},
			MUKELLEF: {
				ROOT: 'Mükellef Sorumlusu İşlemleri',
				ADD: 'Mükellef Sorumlusu Ekle',
				LIST: 'Mükellef Sorumlusu Listesi',
			},
			DEFTER: {
				ROOT: 'Defter İşlemleri',
				ADD: 'Aylık Veri Yükle',
				LIST: 'Kaynak Veri Listesi',
			},
			ANNOUNCEMENT: {
				ROOT: 'Duyuru İşlemleri',
				ADD: 'Duyuru Ekle',
				LIST: 'Duyuru Listesi'
			}
		},
		AUTH: {
			LOGIN: {
				TITLE: 'Giriş Yap',
				EMAIL: 'E - Posta',
				PASSWORD: 'Parola',
				SUBMIT_BUTTON: 'GİRİŞ YAP'
			}
		},
		DASHBOARD: {
			ACTIVE_COMPANY_COUNT: 'Aktif Şirket Sayısı',
			ACTIVE_COMPANY_DESC: 'Size ait sistemde kayıtlı bulunan şirket sayısı.',
			UPLOAD_FILE_COUNTER: 'Yüklenen Defter Sayısı',
			UPLOAD_FILE_DESC: 'Şirketlerinize ait yüklenen defter sayısı.'
		},
		USER: {
			FORM: {
				USER_CARD_TITLE: 'Yeni Kullanıcı Ekle - Kullanıcı Bilgileri',
				USER_CARD_UPDATE_TITLE: 'Kullanıcı Güncelle - Kullanıcı Bilgileri',
				COMPANY: 'Şirket Adı',
				COMPANY_HOLDER: 'Şirket seçiniz.',
				TYPE: 'Kullanıcı Tipi',
				TYPE_HOLDER: 'Kullanıcı Tipi seçiniz.',
				NAME: 'Adı',
				NAME_HOLDER: 'Ad giriniz.',
				SURNAME: 'Soyadı',
				SURNAME_HOLDER: 'Soyad giriniz.',
				EMAIL: 'E - Posta Adresi',
				EMAIL_HOLDER: 'E - Posta Adresi giriniz. (Örn: kullanici@sirket.com.tr)',
				PASSWORD: 'Kullanıcı Parolası',
				PASSWORD_HOLDER: 'Kullanıcı Parolası giriniz.',
				TELEPHONE: 'Telefon Numarası',
				TELEPHONE_HOLDER: 'Telefon Numarası giriniz. (Örn: (555) 555 55 55)',
				SUBMIT: 'Yeni Kullanıcı Ekle',
				UPDATE: 'Kullanıcıyı Güncelle',
			},
			LIST: {
				TITLE: 'Tüm Kullanıcıları Listele',
				FILTER: 'Kullanıcılar Tablosunda Arama...',
				BACK_TO_LIST: 'Kullanıcı Listesine Dön',
				ADD_USER: 'Yeni Kullanıcı Oluştur',
				NO_COMPANY: 'Kullanıcı şirketi bulunmuyor.',
				COMPANY_COL: 'Şirket Adı',
				ROLE_COL: 'Kullanıcı Tipi',
				EMAIL_COL: 'E - Posta',
				NAME_COL: 'Adı',
				SURNAME_COL: 'Soyadı',
				TELEPHONE_COL: 'Telefon No.',
				PROCESS_COL: 'İşlemler',
				DELETE_TITLE: 'Kullanıcı Silme',
				DELETE_DESC: 'Bu işlem geri alınamaz. Onaylıyor musunuz?',
				CLEAR: 'Temizle'
			}
		},
		MUKELLEF: {
			FORM: {
				MUKELLEF_CARD_TITLE: 'Yeni Mükellef Sorumlusu Ekle - Mükellef Sorumlusu Bilgileri',
				MUKELLEF_CARD_UPDATE_TITLE: 'Mükellef Sorumlusu Güncelle - Mükellef Sorumlusu Bilgileri',
				COMPANY_HOLDER: 'Şirket seçiniz.',
				MUKELLEF_HOLDER: 'Mükellef Tipi seçiniz.',
				NAME_SURNAME_HOLDER: 'Ad ve Soyad giriniz.',
				EMAIL_HOLDER: 'E - Posta Adresi giriniz.',
				ADDRESS_BUILD_NO_HOLDER: 'Bina Numarası giriniz.',
				ADDRESS_STREET_HOLDER: 'Sokak giriniz.',
				ADDRESS_MAIN_STREET_HOLDER: 'Cadde giriniz.',
				ADDRESS_ZIP_HOLDER: 'Mahalle (ZIP Kodu) giriniz.',
				ADDRESS_CITY_HOLDER: 'Şehir giriniz.',
				ADDRESS_COUNTRY_HOLDER: 'Ülke giriniz.',
				TELEPHONE_DESC_HOLDER: 'Telefon Açıklaması giriniz.',
				TELEPHONE_NUMBER_HOLDER: 'Telefon Numarası giriniz.',
				FAX_NUMBER_HOLDER: 'Fax Numarası giriniz.',
				APPLICATION_DATE_HOLDER: 'Sözleşme Tarihi seçiniz.',
				APPLICATION_NUMBER_HOLDER: 'Sözleşme Numarası giriniz.',
				APPLICATION_TYPE_HOLDER: 'Sözleşme Tipi Açıklaması giriniz.',
				SUBMIT: 'Yeni Mükellef Sorumlusu Ekle',
				UPDATE: 'Mükellef Sorumlusu Güncelle',
			},
			LIST: {
				TITLE: 'Tüm Mükellef Sorumlularını Listele',
				FILTER: 'Mükellef Sorumluları Tablosunda Arama...',
				BACK_TO_LIST: 'Mükellef Sorumlu Listesine Dön',
				ADD_MUKELLEF: 'Yeni Mükellef Sorumlusu Oluştur',
				NO_COMPANY: 'Kullanıcı şirketi bulunmuyor.',
				COMPANY_COL: 'Şirket Adı',
				NAME_SURNAME_COL: 'Adı Soyadı',
				CITY_COL: 'Şehir',
				COUNTRY_COL: 'Ülke',
				TELEPHONE_DESC_COL: 'Telefon Açıklama',
				TELEPHONE_COL: 'Telefon No.',
				FAX_COL: 'Fax No.',
				EMAIL_COL: 'E - Posta',
				APPLICATION_DATE_COL: 'Sözleşme Tarihi',
				APPLICATION_NO_COL: 'Sözleşme No.',
				PROCESS_COL: 'İşlemler',
				DELETE_TITLE: 'Mükellef Sorumlusu Silme',
				DELETE_DESC: 'Bu işlem geri alınamaz. Onaylıyor musunuz?',
				CLEAR: 'Temizle',
			}
		},
		DEFTER: {
			FORM: {
				COMPANY_HOLDER: 'Şirket Seçiniz.',
				BRANCH_HOLDER: 'Şube Seçiniz.',
				YEAR_HOLDER: 'Yıl Seçiniz.',
				MONTH_HOLDER: 'Ay Seçiniz.',
				SUBMIT: 'Dosya Yükle',
				SUCCESS_ERROR_MODAL_TITLE: 'Yükleme Sırasında Oluşacak Hatalar ve Özel Durumlar',
				ERROR_MODAL_TITLE: 'Yükleme Sırasında Oluşan Hatalar',
				SUCCESS_MODAL_TITLE: 'Yükleme Sırasında Oluşan Başarılar',
				SCHEMA_ERROR_MODAL_TITLE: 'Şema Kontrol Sırasında Oluşan Hatalar',
				SCHEMATRON_ERROR_MODAL_TITLE: 'Şematron Kontrol Sırasında Oluşan Hatalar'
			},
			LIST: {
				TITLE: 'Tüm Yüklenen Defterler Listesi',
				TITLE_USED_SIZE: 'Şirkete Ait Kullanılan Toplam Boyut',
				TITLE_ADD: 'Yeni Kaynak Veri Yükle',
				BACK_TO_LIST: 'Defter Listesine Dön',
				ADD_DEFTER: 'Yeni Kaynak Veri Oluştur / Yükle',
				COMPANY_COL: 'Şirket Adı',
				YEAR_COL: 'Yıl',
				MONTH_COL: 'Ay',
				TOTAL_DEBT_COL: 'Toplam Borç',
				TAX_NO_COL: 'Vergi No',
				TOTAL_CREDIT_COL: 'Toplam Kredi',
				FIRST_HEADER_NO_COL: 'İlk Yevmiye No.',
				LAST_HEADER_NO_COL: 'Son Yevmiye No.',
				STATUS_COL: 'Durum',
				PROCESS_COL: 'İşlemler',
				DELETE_TITLE: 'Defter Silme',
				DELETE_DESC: 'Döneme ait tüm defterleri ve kaynak veri dosyalarınızı siliyorsunuz. Onaylıyor musunuz?',
				FILE_TYPE_COL: 'Dosya Türü',
				FILE_SIZE_COL: 'Dosya Boyutu',
				FROM_DATE_COL: 'Başlangıç Tarihi',
				TO_DATE_COL: 'Bitiş Tarihi',
				BRANCH_COL: 'Şubeli Defter',
				TAX_FREE_COL: 'Vergi Detaysız Berat',
				COVER_COL: 'Aylık Girdi Durumu',
				ALL_COMPANY: 'Tüm Şirketler',
				FOR_SEARCH_COMPANY: 'Şirket Aramak İçin...',
				USED_SIZE: 'Kullanılan Toplam Boyut'
			}
		},
		COMPANY: {
			FORM: {
				USER_CARD_TITLE: 'Yeni Şirket Ekle - Kullanıcı Bilgileri (Şirket Sorumlusu)',
				COMPANY_CARD_TITLE: 'Yeni Şirket Ekle - Şirket Bilgileri',
				USER_CARD_UPDATE_TITLE: 'Şirket Güncelle - Kullanıcı Bilgileri (Şirket Sorumlusu)',
				COMPANY_CARD_UPDATE_TITLE: 'Şirket Güncelle - Şirket Bilgileri',
				COMPANY_HOLDER: 'Şirket Adı giriniz.',
				TEX_NUMBER_HOLDER: 'Vergi Numarası giriniz.',
				EMAIL_HOLDER: 'E - Posta adresi giriniz. (Örn: destek@sirket.com.tr)',
				URL_HOLDER: 'WEB Sayfası (URL) giriniz. (Örn: www.sirket.com.tr)',
				NACE_HOLDER: 'NACE Kodu giriniz.',
				TELEPHONE_DESC_HOLDER: 'Telefon Açıklaması giriniz.',
				TELEPHONE_NUMBER_HOLDER: 'Telefon Numarası giriniz.',
				FAX_NUMBER_HOLDER: 'Fax Numarası giriniz.',
				ADDRESS_BUILD_NO_HOLDER: 'Bina Numarası giriniz.',
				ADDRESS_STREET_HOLDER: 'Sokak giriniz.',
				ADDRESS_MAIN_STREET_HOLDER: 'Cadde giriniz.',
				ADDRESS_ZIP_HOLDER: 'Mahalle (ZIP Kodu) giriniz.',
				ADDRESS_CITY_HOLDER: 'Şehir giriniz.',
				ADDRESS_COUNTRY_HOLDER: 'Ülke giriniz.',
				FINANCIAL_YEAR_FROM_DATE_HOLDER: 'Finansal Yıl Başlangıcı seçiniz.',
				FINANCIAL_YEAR_TO_DATE_HOLDER: 'Finansal Yıl Bitişi seçiniz.',
				LIQUIDATE_FROM_DATE_HOLDER: 'Tasfiye Başlangıcı seçiniz.',
				LIQUIDATE_TO_DATE_HOLDER: 'Tasfiye Bitişi seçiniz.',
				REGISTER_DATE_HOLDER: 'Kayıt Tarihi seçiniz.',
				IS_ACTIVE_HOLDER: 'Şirket Hesap Durumu seçiniz:',
				IS_ACTIVE_TRUE_RADIO: 'Şirket Aktif',
				IS_ACTIVE_FALSE_RADIO: 'Şirket Pasif',
				IS_BRANCH_HOLDER: 'Şirket Şube Durumu seçiniz:',
				IS_BRANCH_TRUE_RADIO: 'Şubeli Giriş',
				IS_BRANCH_FALSE_RADIO: 'Şubesiz Giriş',
				CUSTOMER_TYPE_HOLDER: 'Şirket Türü',
				CUSTOMER_TYPE_REAL_RADIO: 'Gerçek Kişi',
				CUSTOMER_TYPE_LEGAL_RADIO: 'Tüzel Kişi',
				CURRENCY_HOLDER: 'Para Birimi',
				SUBMIT: 'Yeni Şirket Oluştur',
				UPDATE: 'Şirket Bilgilerini Güncelle'
			},
			LIST: {
				TITLE: 'Tüm Şirketleri Listele',
				FILTER: 'Şirket Tablosunda Arama...',
				BACK_TO_LIST: 'Şirket Listesine Dön',
				ADD_COMPANY: 'Yeni Şirket Oluştur',
				COMPANY_COL: 'Şirket Adı',
				CUSTOMER_COL: 'Müşteri Tipi',
				TELEPHONE_COL: 'Telefon No.',
				REGISTER_FROM_DATE_COL: 'Kayıt Tarihi',
				REGISTER_STATUS_COL: 'Üyelik Durumu',
				LIQUIDATE_COL: 'Tasfiye Durumu',
				PASSIVE: 'Pasif',
				PASSIVE_TITLE: 'Şirket Pasifleştir',
				PASSIVE_DESC: 'Onaylıyor musunuz?',
				ACTIVE: 'Aktif',
				ACTIVE_TITLE: 'Şirket Aktifleştir',
				ACTIVE_DESC: 'İşlem sonrasında şirket "pasifleştirilebilir.". Onaylıyor musunuz?',
				LIQUIDATE_TITLE: 'Mükellef Tasfiye Et',
				LIQUIDATE_DESC: 'Mükellef tasfiye süreci başlatıldıktan sonra geri alınamaz.',
				PROCESS_COL: 'İşlemler',
				TAX_NUMBER_COL: 'Vergi No.',
				COMPANY_ADMIN_COL: 'Şirket Admini',
				COMPANY_ADMIN_TEL_COL: 'Admin Telefon No.',
				CLEAR: 'Temizle'
			}
		},
		BRANCH: {
			FORM: {
				BRANCH_CARD_TITLE: 'Yeni Şube Ekle - Şube Bilgileri',
				BRANCH_CARD_UPDATE_TITLE: 'Şube Güncelle - Şube Bilgileri',
				COMPANY_HOLDER: 'Şirket seçiniz.',
				CODE_HOLDER: 'Şube Kodu giriniz. (Sadece "Sayısal" değer geçerlidir. Örn: 0001)',
				NAME_HOLDER: 'Şube Adı giriniz. (Örn: Ankara Şubesi)',
				URL_HOLDER: 'WEB Sayfası (URL) giriniz. (Örn: www.sirket.com.tr)',
				TELEPHONE_NUMBER_HOLDER: 'Telefon Numarası giriniz.',
				FAX_NUMBER_HOLDER: 'Fax Numarası giriniz.',
				ADDRESS_BUILD_NO_HOLDER: 'Bina Numarası giriniz.',
				ADDRESS_STREET_HOLDER: 'Sokak giriniz.',
				ADDRESS_MAIN_STREET_HOLDER: 'Cadde giriniz.',
				ADDRESS_ZIP_HOLDER: 'Mahalle (ZIP Kodu) giriniz.',
				ADDRESS_CITY_HOLDER: 'Şehir giriniz.',
				ADDRESS_COUNTRY_HOLDER: 'Ülke giriniz.',
				REGISTER_DATE_HOLDER: 'Kayıt Tarihi seçiniz.',
				OPENED_DATE_HOLDER: 'Açılış Tarihi seçiniz.',
				CLOSED_DATE_HOLDER: 'Kapanış Tarihi seçiniz.',
				SUBMIT: 'Yeni Şube Oluştur',
				UPDATE: 'Şube Bilgilerini Güncelle',
			},
			LIST: {
				TITLE: 'Tüm Şubeleri Listele',
				FILTER: 'Şubeler Tablosunda Arama...',
				BACK_TO_LIST: 'Şube Listesine Dön',
				ADD_BRANCH: 'Yeni Şube Oluştur',
				COMPANY_COL: 'Şirket Adı',
				BRANCH_CODE_COL: 'Şube Kodu',
				BRANCH_NAME_COL: 'Şube Adı',
				TELEPHONE_NUMBER_COL: 'Telefon No.',
				REGISTER_STATUS_COL: 'Üyelik Durumu',
				DELETE_TITLE: 'Şube Silme',
				DELETE_DESC: 'Bu işlem geri alınamaz. Onaylıyor musunuz?',
				PROCESS_COL: 'İşlemler',
				CLEAR: 'Temizle'
			}
		},
		ANNOUNCEMENT: {
			FORM: {
				ANNOUNCEMENT_CARD_TITLE: 'Yeni Duyuru Ekle Bilgileri',
				TITLE: 'Duyuru Başlığı Giriniz.',
				DESCRIPTION: 'Duyurunuzu Yazınız.',
				START_DATE: 'Duyuru Başlangıç Tarihi Seçiniz.',
				END_DATE: 'Duyuru Bitiş Tarihini Seçiniz.',
				TYPE: 'Duyuru Tipi Seçiniz.',
				SUBMIT: 'Yeni Duyuru Oluştur',
				UPDATE: 'Duyuru Bilgilerini Güncelle',
			},
			LIST: {
				BACK_TO_LIST: 'Duyuru Listesine Dön',
				TITLE: 'Tüm Duyuruları Listele',
				FILTER: 'Duyuru Tablosunda Arama...',
				ADD_ANNOUNCEMENT: 'Yeni Duyuru Oluştur',
				TITLE_COL: 'Başlık',
				DESC_COL: 'Açıklama',
				TYPE_COL: 'Duyuru Tipi',
				START_DATE_COL: 'Başlangıç Tarih',
				END_DATE_COL: 'Son Tarih',
				DATE_CREATED_COL: 'Oluşturulma Tarihi',
				DELETE_TITLE: 'Duyuru Silme',
				DELETE_DESC: 'Bu işlem geri alınamaz. Onaylıyor musunuz ?',
				PROCESS_COL: 'İşlemler',
				CLEAR: 'Temizle'
			}
		},
		DEFTER_STATE: {
			CREATED: 'İMZA VE KONTROL AŞAMASINDA',
			CANCELED: 'İPTAL EDİLDİ',
			WAITING_GIB: 'GİB ONAYI BEKLENİYOR',
			SENDED_GIB: 'GİB\'E GÖNDERİLDİ',
			ACCEPTED_GIB: 'GİB TARAFINDAN KABUL EDİLDİ',
			ERROR_GIB: 'GİB KAYNAKLI HATA OLUŞTU',
			READY_FOR_GIB: "GİB'e GÖNDERİME HAZIR"
		},
		FILE_STATE: {
			VALID_INPUT: 'GEÇERLİ VERİ',
			INVALID_INPUT: 'GEÇERSİZ VERİ',
			CANCELED: 'İPTAL EDİLDİ',
			CREATED: 'OLUŞTURULDU',
			PASS_SCHEMA_TEST: 'ŞEMA TESTİNİ GEÇTİ',
			PASS_SCHEMATRON_TEST: 'ŞEMATRON TESTİNİ GEÇTİ',
			SIGNED: 'İMZALANDI',
		},
		TEL_TYPE: {
			BOOKKEEPER: 'Defter Tutan (Bookkeeper)',
			CONTROLLER: 'Muhasebeci (Controller)',
			DIRECT: 'Direkt (Direct)',
			FAX: 'Faks (Fax)',
			INVESTOR_RELATIONS: 'Yatırımcı İlişkileri (Investor Relations)',
			MAIN: 'Ana Telefon (Main)',
			SWITCHBOARD: 'Santral (Switchboard)',
			OTHER: 'Diğer (Other)',
		},
		USER_ROLE: {
			SYSTEM_ADMIN: 'Sistem Yöneticisi',
			COMPANY_ADMIN: 'Şirket Yöneticisi',
			COMPANY_USER: 'Şirket Kullanıcısı',
		},
		MONTHS: {
			1: 'Ocak',
			2: 'Şubat',
			3: 'Mart',
			4: 'Nisan',
			5: 'Mayıs',
			6: 'Haziran',
			7: 'Temmuz',
			8: 'Ağustos',
			9: 'Eylül',
			10: 'Ekim',
			11: 'Kasım',
			12: 'Aralık'
		}
	}
};
